import React from 'react';

import AKIcon, { type IconProps as AKIconProps, type CustomGlyphProps } from '@atlaskit/icon';
import IntroductionAddIcon from '@atlaskit/icon-lab/core/text-introduction-add';
import { token } from '@atlaskit/tokens';

const IconGlyph = (props: CustomGlyphProps) => (
	<svg
		width={14}
		height="100%"
		viewBox="0 0 14 15"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
		className={props.className}
		// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
		style={props.style}
		aria-label={props['aria-label']}
		aria-hidden={props['aria-hidden']}
		focusable={props.focusable}
		role={props.role}
		tabIndex={props.tabIndex}
		data-testid={props['data-testid']}
		id={props.id}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M15 9.5L1 9.5L1 11L15 11V9.5ZM8 13.5L1 13.5L1 15L8 15V13.5Z"
			fill="currentColor"
		/>
		<path
			d="M1.75 5C2.16421 5 2.5 5.33579 2.5 5.75C2.5 6.16421 2.16421 6.5 1.75 6.5C1.33579 6.5 1 6.16421 1 5.75C1 5.33579 1.33579 5 1.75 5Z"
			fill="currentColor"
		/>
		<path
			d="M1.75 1C2.16421 1 2.5 1.33579 2.5 1.75C2.5 2.16421 2.16421 2.5 1.75 2.5C1.33579 2.5 1 2.16421 1 1.75C1 1.33579 1.33579 1 1.75 1Z"
			fill="currentColor"
		/>
		<path
			d="M5.625 5.75C5.625 5.33579 5.28921 5 4.875 5C4.46079 5 4.125 5.33579 4.125 5.75C4.125 6.16421 4.46079 6.5 4.875 6.5C5.28921 6.5 5.625 6.16421 5.625 5.75Z"
			fill="currentColor"
		/>
		<path
			d="M4.875 1C5.28921 1 5.625 1.33579 5.625 1.75C5.625 2.16421 5.28921 2.5 4.875 2.5C4.46079 2.5 4.125 2.16421 4.125 1.75C4.125 1.33579 4.46079 1 4.875 1Z"
			fill="currentColor"
		/>
		<path
			d="M8.75 5.75C8.75 5.33579 8.41421 5 8 5C7.58579 5 7.25 5.33579 7.25 5.75C7.25 6.16421 7.58579 6.5 8 6.5C8.41421 6.5 8.75 6.16421 8.75 5.75Z"
			fill="currentColor"
		/>
		<path
			d="M8 1C8.41421 1 8.75 1.33579 8.75 1.75C8.75 2.16421 8.41421 2.5 8 2.5C7.58579 2.5 7.25 2.16421 7.25 1.75C7.25 1.33579 7.58579 1 8 1Z"
			fill="currentColor"
		/>
		<path
			d="M11.875 5.75C11.875 5.33579 11.5392 5 11.125 5C10.7108 5 10.375 5.33579 10.375 5.75C10.375 6.16421 10.7108 6.5 11.125 6.5C11.5392 6.5 11.875 6.16421 11.875 5.75Z"
			fill="currentColor"
		/>
		<path
			d="M11.125 1C11.5392 1 11.875 1.33579 11.875 1.75C11.875 2.16421 11.5392 2.5 11.125 2.5C10.7108 2.5 10.375 2.16421 10.375 1.75C10.375 1.33579 10.7108 1 11.125 1Z"
			fill="currentColor"
		/>
		<path
			d="M15 5.75C15 5.33579 14.6642 5 14.25 5C13.8358 5 13.5 5.33579 13.5 5.75C13.5 6.16421 13.8358 6.5 14.25 6.5C14.6642 6.5 15 6.16421 15 5.75Z"
			fill="currentColor"
		/>
		<path
			d="M14.25 1C14.6642 1 15 1.33579 15 1.75C15 2.16421 14.6642 2.5 14.25 2.5C13.8358 2.5 13.5 2.16421 13.5 1.75C13.5 1.33579 13.8358 1 14.25 1Z"
			fill="currentColor"
		/>
	</svg>
);

export const InsertAtTopIcon = () => (
	<IntroductionAddIcon
		label=""
		spacing="spacious"
		LEGACY_fallbackIcon={(props: AKIconProps) => (
			<AKIcon
				glyph={IconGlyph}
				label={props.label}
				size={props.size}
				primaryColor={props.primaryColor}
				secondaryColor={props.secondaryColor}
				testId={props.testId}
			/>
		)}
		LEGACY_secondaryColor={token('color.icon')}
	/>
);
